import Button from './Button';

interface InlineErrorDisplayProps {
    message: string;
    onDismiss?: () => void;
}

export default function InlineErrorDisplay({ message, onDismiss }: InlineErrorDisplayProps) {
    return (
        <div className="mb-6 bg-red-50 border border-red-200 rounded-md p-4">
            <div className="flex">
                <div className="text-red-400">
                    <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
                    </svg>
                </div>
                <div className="ml-3 flex-1">
                    <h3 className="text-sm font-medium text-red-800">Error</h3>
                    <div className="mt-2 text-sm text-red-700">{message}</div>
                </div>
                {onDismiss && (
                    <div className="ml-auto">
                        <Button
                            type="button"
                            variant="ghost"
                            className="inline-flex text-red-400 hover:text-red-600 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2 focus:ring-offset-red-50"
                            onClick={onDismiss}
                            icon={
                                <svg className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                                    <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
                                </svg>
                            }
                        >
                            <span className="sr-only">Dismiss</span>
                        </Button>
                    </div>
                )}
            </div>
        </div>
    );
} 